import type { PreferencesViewProps as Props } from '../types'
import { preview } from '@/components/form/preview'
import { Header } from './components/Header'
import { useTexts } from '../hooks/useTexts'
import { useCreateFormatLanguage } from '../hooks/useCreateFormatLanguage'

export function PreferencesView(props: Props) {
  const { onEdit, formValues, supportedLanguages } = props
  const texts = useTexts()
  const formatLanguage = useCreateFormatLanguage(supportedLanguages)

  return (
    <preview.Root applyPendingFitMapOnMount rightBorder={false} header={<Header onEdit={onEdit} />}>
      <preview.Field testId="notification-language" label={texts.notificationLanguage}>
        {formatLanguage(formValues.notificationLanguage)}
      </preview.Field>

      <preview.Field testId="company-form-name" label={texts.companyFromName}>
        {formValues.companyFromName}
      </preview.Field>

      <preview.Field testId="time-format" label={texts.timeFormat}>
        {texts.timeFormatExample(formValues.timeFormat)}
      </preview.Field>

      <preview.Field testId="date-format" label={texts.dateFormat}>
        {texts.dateFormatExample(formValues.dateFormat)}
      </preview.Field>
    </preview.Root>
  )
}
